import { useQuery } from 'react-query';

import {
  type RecommendedReportersResponse,
  getRecommendedReporters,
} from '@utils/backend-api/subscriber_directory';

const RECOMMENDED_REPORTERS_KEY = 'RECOMMENDED_REPORTERS';

export default function useRecommendedReporters() {
  const { data, isLoading } = useQuery<RecommendedReportersResponse>(
    [RECOMMENDED_REPORTERS_KEY],
    getRecommendedReporters
  );

  return {
    followsReporters: data?.follows_reporters,
    isLoadingReporters: isLoading,
    reporters: data?.reporters,
  };
}
